import { render, staticRenderFns } from "./CollegeSubscriptionPracticeTestsChildTopic.vue?vue&type=template&id=256baaae"
import script from "./CollegeSubscriptionPracticeTestsChildTopic.vue?vue&type=script&lang=js"
export * from "./CollegeSubscriptionPracticeTestsChildTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports